import { youtubeId } from "../live/Video";

/**
 * ═══ D'OÙ VIENT LE REPLAY, ET SOUS QUELLE FORME ON PEUT L'AFFICHER ═══
 *
 * La V1 range UNE adresse (`replayVimeoUrl`) et la pose telle quelle dans un cadre
 * (`screens/Replay.jsx`). Ça marche parce que le back office demande une adresse
 * d'insertion Vimeo. Coller le lien de la barre d'adresse, le geste évident, donne un
 * cadre noir : ni `vimeo.com/123`, ni `youtube.com/watch?v=…` ne s'affichent dans une
 * `iframe`. Ici on déduit l'adresse d'insertion de ce qui a été collé, comme le direct.
 *
 * ⚠️ UNE SEULE CLÉ, `FO_MEETING_V2_REP_URL`. Les deux noms V1 (`FO_MEETING_REPLAY_VIMEO_URL`,
 * `replayVimeoUrl`) étaient lus en repli à l'affichage ; retiré le 2026-09-26 : ce que
 * montre la page doit se lire dans le panneau (voir `routes/Replay.tsx`).
 */

/**
 * L'ADRESSE D'INSERTION, à partir de ce qui a été collé.
 *
 * ⚠️ UNE ADRESSE DE LECTEUR VIMEO SE GARDE ENTIÈRE. Une vidéo non répertoriée porte un
 * jeton (`?h=…`) sans lequel le lecteur refuse ; le ramener à son identifiant nu,
 * comme le fait le direct, aurait cassé exactement ce que le back office demandait de
 * coller. Même précaution pour `vimeo.com/123/abcdef` : le second segment est ce jeton.
 *
 * ⚠️ PAS D'AUTOPLAY, à la différence du direct : on arrive sur un replay pour choisir
 * de le lancer, pas pour se le faire imposer avec le son.
 *
 * Toute autre adresse `https://` est prise telle quelle, comme la V1 le faisait : un
 * hébergeur qu'on ne connaît pas fournit lui-même son adresse d'insertion.
 */
export function replayEmbedUrl(raw: string): string | null {
  const value = raw.trim();
  if (value === "") return null;

  if (/youtube\.com|youtu\.be/i.test(value)) {
    const id = youtubeId(value);
    return id ? `https://www.youtube.com/embed/${id}` : null;
  }

  if (/vimeo\.com/i.test(value)) {
    if (/^https?:\/\/player\.vimeo\.com\//i.test(value)) return value;
    const found = value.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-z0-9]+))?/i);
    if (!found?.[1]) return null;
    const hash = found[2] ? `?h=${found[2]}` : "";
    return `https://player.vimeo.com/video/${found[1]}${hash}`;
  }

  return /^https?:\/\//i.test(value) ? value : null;
}
